import 'bootstrap'
import 'jquery.easing';
import 'svgxuse'
import './plugins/scrollevent'
import './plugins/anchorlink'
import init from './module/init';
import FEATURE from './pages/feature';
import ENTRYFORM from './pages/entry';

const [w,d,l] = [window,document,location]

init()

switch(l.pathname){
  case '/':
  case '/recruit/': FEATURE(); break
  case '/entry/': ENTRYFORM(); break
}
